import { FeatheredImage } from "../../FeatheredImage";

const A = "/brand";
const IMG = `${A}/blueprint4joy-believinghappy-binoculars.jpg`;
const ALT = "Lara laughing while looking through binoculars, wearing a bright pink blazer, in a bright indoor space.";

export function NothingWrong() {
  return (
    <section data-testid="believing-happy-nothing-wrong-section" className="relative bg-[#FAFAF8]">
      <div className="relative w-full reveal pt-[36px] md:pt-[47px] pb-[45px] md:pb-[60px]">
        {/* Desktop image half-band, right side, bleeds to the viewport's
            top/right/bottom edge (About Hero pattern). Only the inner
            (left) edge is feathered into the section's #FAFAF8 bg. */}
        <div className="hidden lg:block absolute inset-y-0 right-0 w-[50%]">
          <FeatheredImage
            src={IMG}
            alt={ALT}
            testId="believing-happy-nothing-wrong-image"
            objectPosition="50% 12%"
            featherLeft={44}
            className="absolute inset-0"
          />
        </div>

        {/* Mobile image stacked on top */}
        <div className="lg:hidden relative w-full aspect-[4/5] mt-6">
          <FeatheredImage
            src={IMG}
            alt={ALT}
            testId="believing-happy-nothing-wrong-image-mobile"
            objectPosition="50% 10%"
            featherBottom={20}
            className="absolute inset-0"
          />
        </div>

        {/* Text on the clean left */}
        <div className="relative z-[2] max-w-7xl mx-auto px-6 md:px-10 pt-8 lg:pt-0">
          <div className="w-full lg:w-[50%]">
            <div className="max-w-xl">
              <h2 className="font-display text-4xl md:text-5xl lg:text-[52px] leading-[1.08] tracking-tight text-[#1C1917] mb-6">
                Nothing has to be terribly wrong.
              </h2>
              <div className="space-y-4 text-[22px] md:text-[24px] leading-relaxed text-[#57534E]">
                <p>Your life may actually be pretty good.</p>
                <p>
                  You&rsquo;ve built things you&rsquo;re proud of. There are
                  people you love. You laugh. You handle what needs handling.
                </p>
                <p>
                  From the outside, there may be absolutely nothing anyone
                  would point to and say, There&rsquo;s the problem.
                </p>
                <p className="text-[#1C1917]">And still&hellip;</p>
                <p className="text-[#1C1917]">Something feels a little off.</p>
                <p>
                  Maybe there are parts of your life you&rsquo;ve outgrown.
                  Things you keep saying you&rsquo;ll do someday. Or
                  something you can&rsquo;t quite name yet.
                </p>
                <p>
                  You don&rsquo;t need to blow up a perfectly good life to
                  find out what&rsquo;s missing.
                </p>
                <p>
                  Sometimes you just need to stop long enough to ask what
                  you want now.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
